import { Directive, ElementRef, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from "@angular/core";
import { CoreCOMService } from "../../services/com.service";
import { CoreLogService } from "../../services/log.service";
import { CoreImageService } from "../../services/image.service";
import { SafeFileSystem } from "../../services/safeFileSystem.service";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../../services/http.service";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLanguageService } from "../../services/language.service";

/**
    to create the backend  
    background-image: url(loadingImageURL);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
 */

/** Images Direktive für <img class="ya_image" [src]="model.image_name" /> **/
@Directive({
  selector: "img.ya_image"
})
export class CoreImagesDirective implements OnInit, OnChanges, OnDestroy {
  @Input() private src: string;

  private _coreImageService: CoreImageService = null;
  private _subscription: Subscription = null;
  private langSubscriber: Subscription = null;
  private lastSetAlt: string = null;

  constructor(
    private _el: ElementRef,
    _coreCOMService: CoreCOMService,
    _safeFileSystem: SafeFileSystem,
    private _coreLogService: CoreLogService,
    private _internationalisationService: InternationalisationService,
    private _coreLanguageService: CoreLanguageService,
    http: HttpClient,
    matDialog: MatDialog
  ) {
    this._coreImageService = new CoreImageService(_coreCOMService, _safeFileSystem, _coreLogService, new HttpService(http, matDialog));
  }

  ngOnInit(): void {
    const me = this;
    me.updateAltText();
    me.langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.updateAltText(); // Aktualisiere Alt-Texte bei Sprachänderung
    });
  }

  private async setImage(path: string) {
    const me = this;

    me.updateAltText();
    if (path && path.length > 0) {
      // me._el.nativeElement.setAttribute("src", CoreImageService.loadingImageURL); // erst auf vorhandenes Image prüfen
      // Prüfen, ob das Image schon runtergeladen ist, dann gleich dieses Image anzeigen, egal in welcher Auflösung.
      const localImageURL = await me._coreImageService.getLocalURLByPath(path);
      if (localImageURL !== "") {
        me._el.nativeElement.setAttribute("src", localImageURL);
      } else {
        me._el.nativeElement.setAttribute("src", CoreImageService.loadingImageURL);
      }
      let ignore_assets: boolean = false; // ignore_assets ist default false
      let image_size: number = -1; // -1 image_size is not nessesary
      if (me._el.nativeElement.hasAttribute("ignore_assets")) {
        ignore_assets = (me._el.nativeElement.getAttribute("ignore_assets") === "1");
        if (me._el.nativeElement.hasAttribute("image_size")) {
          image_size = parseInt(me._el.nativeElement.getAttribute("image_size"), 10);
        }
      }
      me._subscription = me._coreImageService.getURLByPath(path, ignore_assets, image_size).subscribe((url) => {
        me._el.nativeElement.setAttribute("src", url);
      }, (error) => {
        me._el.nativeElement.setAttribute("src", me.getErrorSrc());
        me._coreLogService.error("CoreImagesDirective.ngOnInit", "getURLByPath(" + path + ")", error);
      }, () => {
        if (me._subscription !== null) {
          me._subscription.unsubscribe();
          me._subscription = null;
        }
      });
    } else {
      me._el.nativeElement.setAttribute("src", me.getErrorSrc());
    }
  }

  /** ermittelt, wenn übergeben, src dass im fehlerfall angezeigt werden soll, andernfalls default errorImage */
  private getErrorSrc(): string {
    const me = this;
    const error_src = me._el.nativeElement.getAttribute("error_src");
    if (error_src) {
      return error_src;
    } else {
      return CoreImageService.errorImageURL;
    }
  }

  private updateAltText(): void {
    const me = this;
    // the alt text is only set if the webshop is running, when the SOT runs, the alt text is set to empty 
    if (this._coreLanguageService["_sotLanguageService"]) {
      return;
    }
    const currentAlt = me._el.nativeElement.getAttribute("alt");

    if (!currentAlt || currentAlt.trim() === "") {
      let translatedAlt = "";
      if (this._coreLanguageService) {
        try {
          translatedAlt = this._coreLanguageService.value("phA11Y_image_alt_text");
        } catch (e) {
          translatedAlt = "";
        }
        if (
          translatedAlt &&
          translatedAlt.trim() !== "" &&
          translatedAlt !== "phA11Y_image_alt_text"
        ) {
          me._el.nativeElement.setAttribute("alt", translatedAlt);
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const me = this;
    const src = changes["src"];
    if (src && (src.firstChange || src.currentValue !== src.previousValue)) {
      if (src.firstChange) {
        me._el.nativeElement.setAttribute("onerror", "this.onerror=null;this.src='" + me.getErrorSrc() + "';");
      }
      me.setImage(src.currentValue);
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._subscription) {
      me._subscription.unsubscribe();
    }
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }
}
